import { TCacheConfig } from "@core/services/interfaces/geralEmplacamento/cache/ICacheService";

const cacheConfig: TCacheConfig = {
  // Endpoints
  getCacheEndpoint: "/api/Geral/Cache",
  deleteCacheEndpoint: "/api/Geral/Cache",
}

export default cacheConfig;